export default __webpack_public_path__ + "static/media/icon_arrow_right_black.16537ab5.svg";